<div class="task-labels">
    @for(label of labels; track label.id){ 
        <span class="badge text-bg-light me-2" [ngStyle]="{'border': '1px solid ' + label.color + '10'}"> 
            <i class="fa-solid fa-circle pe-1" [ngStyle]="{'color': label.color}"></i>{{label.name}}
            <i class="fa-regular fa-xmark ps-1" (click)="removeLabel(label)"></i>
        </span> 
    }  
</div>